<template>
  <v-dialog v-model="dialog" max-width="600" :persistent="true">
    <v-card>
      <v-toolbar card dark color="primary">
        <v-toolbar-title>{{ 'app.mobile_app.unable_to_send_menu' | trans }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon dark small @click="close">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <v-container>
          <v-layout row justify-end>
            <v-flex xs12>
              <p v-html="trans('app.mobile_app.unable_to_send_menu_description', {
                'menuStartDate': startDate,
                'menuEndDate': endDate
              })"></p>
              <ul>
                <li v-for="menu in otherMenus" :key="menu.id">
                  <span class="text-bold">{{ formatDate(menu.start_date) }} - {{ formatDate(menu.end_date) }}</span>
                </li>
              </ul>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="close">
          {{ 'app.close' | trans }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import {dateFormatter, FORMAT_DATE} from "../../../utils/dateFormatter";

export default {
  data: function () {
    return {
      dialog: false,
      otherMenus: [],
      menuStartDate: '',
      menuEndDate: ''
    }
  },
  methods: {
    close() {
      this.otherMenus = [];
      this.menuStartDate = '';
      this.menuEndDate = '';
      this.dialog = false;
    },
    open(startDate, endDate, otherMenus) {
      this.menuStartDate = startDate;
      this.menuEndDate = endDate;
      this.otherMenus = otherMenus;
      this.dialog = true;
    },
    formatDate(date) {
      return dateFormatter(date, FORMAT_DATE);
    }
  },
  computed: {
    startDate() {
      return this.formatDate(this.menuStartDate);
    },
    endDate() {
      return this.formatDate(this.menuEndDate);
    },
  }
}
</script>
<style scoped>
  .container {
    text-align: left;
  }
</style>